import { EntityState, EntityType } from './apiTypes.model'

export enum HotelType {
  Apartamentos = 'apartamentos',
  CasasRurales = 'casas_rurales',
  Hotel = 'hotel',
  Villas = 'villas'
}
export interface HotelAuxList {
  accesibilities?: boolean
  active: boolean
  activities?: boolean
  activities_older_children?: boolean
  activities_young_children?: boolean
  adjoining_rooms?: boolean
  aireLibre: boolean
  all_inclusive?: boolean
  all_suites?: boolean
  allowCancelClientExtras: boolean
  allowCancelClientReserve: boolean
  allowChildren?: boolean
  allowClientGetExtras: boolean
  allowCreateTravelRegister: boolean
  allowEvents?: boolean
  allowPets?: boolean
  apartments?: boolean
  autoAssignInAndOutTimeInReserves: boolean
  autoAssingClientExtras: boolean
  autoGeneratedCustomField: boolean
  autoGeneratedCustomFieldOnlyDigits: boolean
  autoGeneratedCustomFieldOnlyLetters: boolean
  autoMarkTravelRegisterAsConfirmed: boolean
  automaticCancelClientReserve: boolean
  autoselectOffer?: boolean
  babuik: boolean
  bar?: boolean
  bathrooms?: boolean
  beach?: boolean
  bed_and_breakfast?: boolean
  billHead?: string
  billingEntityId?: string
  bookingEngineActive: boolean
  bookingEngineAllowChildren?: boolean
  bookingEngineBorderColor?: string
  bookingEngineChildrenMaxAge?: string
  bookingEngineChildrenMinAge?: string
  bookingEngineColor?: string
  bookingEngineComparator: boolean
  bookingEngineHideContact: boolean
  bookingEngineHideHead: boolean
  bookingEngineHideMap: boolean
  bookingEngineHideShortDescription: boolean
  bookingEngineShortModel: boolean
  bookingEngineShowBaby?: boolean
  bookingEngineShowChildren?: boolean
  bookingEngineShowPaidToday: boolean
  businessName?: string
  business_services?: boolean
  cafeBar?: boolean
  car_rental_desk?: boolean
  cardTypeList: string[]
  castle?: boolean
  cheaperOffer: boolean
  checkClientIdentifierAtCheckIn: boolean
  checkCoordinates?: boolean
  checkIn: string
  checkOut: string
  city: string
  cleanService?: boolean
  clientReserveGetCardIfNotExist: boolean
  clientReserveGetCardIfNotValid: boolean
  clientReserveHoursToCancel?: string
  clientReserveHoursToCancelIfCardNotExist?: string
  confirmEmailShowRevenues: boolean
  conventions?: boolean
  coordinate_x?: string
  coordinate_y?: string
  countryId: string
  credit_cards_accepted?: boolean
  currencyCodeList: any[]
  data_port?: boolean
  deleteTravelRegisterToClient: boolean
  dining?: boolean
  dry_cleaning?: boolean
  early_arrival?: boolean
  economy?: boolean
  editTravelRegisterToClient: boolean
  elder_access?: boolean
  email: string
  entityState: EntityState
  entityType: EntityType.HotelAuxList
  entryReportAddress: string
  entryReportCif?: string
  entryReportLegalText?: string
  entryReportName: string
  entryReportTourismRegister: string
  environmentDataId: string
  extended_stay?: boolean
  exteriorJacuzzi?: boolean
  facebook?: string
  family_rooms?: boolean
  farm_ranch?: boolean
  fax?: string
  first_class?: boolean
  food_available?: boolean
  freeParking?: boolean
  freeWifi?: boolean
  free_breakfast?: boolean
  free_cancelation?: boolean
  free_internet?: boolean
  free_local_calls?: boolean
  game_room?: boolean
  golf?: boolean
  googleAnalitics?: string
  googleAnaliticsPayment?: string
  googlePlus?: string
  gym?: boolean
  hasAutoCheckIn: boolean
  horseStables?: boolean
  hot_tub?: boolean
  hotelType: HotelType
  id: string
  identifier?: string
  informantCharge?: string
  informantEmail?: string
  informantFax?: string
  informantName?: string
  informantPhone?: string
  instagram?: string
  internalName: string
  internationalizedNameId?: string
  kids_activities?: boolean
  kitchen_kitchenette?: boolean
  kitchenette?: boolean
  lastCheckIn: string
  late_arrival?: boolean
  late_check_out?: boolean
  location?: string
  lockers_storage?: boolean
  loyalty_rewards_available?: boolean
  luxury?: boolean
  managementCompanyAddress?: string
  managementCompanyBusinessName?: string
  managementCompanyCif?: string
  managementCompanyCity?: string
  managementCompanyFax?: string
  managementCompanyMunicipality?: string
  managementCompanyName?: string
  managementCompanyPhone?: string
  managementCompanyPostalCode?: string
  managementCompanyUrl?: string
  managerEmail?: string
  managerFullName?: string
  managerIdentifier?: string
  maximumCapacity?: string
  meals_included?: boolean
  meetingRoom?: boolean
  minAge?: string
  motel?: boolean
  municipality?: string
  name: string
  naturalEnvironment?: boolean
  non_smoking?: boolean
  notificationDestination: string
  numberPersonWork?: number
  numberPersonWorkNotSalary?: number
  numberPersonWorkSalary?: number
  numberPersonWorkSalaryOptional?: number
  onlyScaPaidException: boolean
  opinionUrl?: string
  orderReserves: boolean
  parking?: boolean
  parking_available?: boolean
  pets_allowed?: boolean
  phone: string
  place: string
  pool?: boolean
  postalCode: string
  priorOffer: boolean
  privateEnvironment?: boolean
  private_bath?: boolean
  receptionAllDay?: boolean
  registerNumber: string
  rentBikes?: boolean
  reportList: any[]
  resort?: boolean
  restaurant?: boolean
  room_service?: boolean
  room_with_a_view?: boolean
  roundPrice?: boolean
  sellInFindBookingEngine: boolean
  sendAllowGetBillToClient: boolean
  sendAllowInquiryBillToClient: boolean
  sendAllowWriteMessagesToClient: boolean
  sendCancellation: boolean
  shared_bath?: boolean
  shortName: string
  showAllEntryReportTravelRegister: boolean
  showBillRegisterNumber: boolean
  showBillReserveData: boolean
  showBillRevenues: boolean
  showClientReserveInfo: boolean
  showEntryForm: boolean
  showEntryReportArrivalTime: boolean
  showEntryReportCharges: boolean
  showEntryReportCreditCard: boolean
  showEntryReportDepartureTime: boolean
  showEntryReportObservations: boolean
  showEntryReportRooms: boolean
  showPriceClientReserve: boolean
  showRentalAgreement: boolean
  showTravelRegisterToClient: boolean
  sostenibilities?: boolean
  spa?: boolean
  stairs_elevator?: boolean
  stars?: string
  stroller_parking?: boolean
  suites?: boolean
  templateBillOwnerAggrementAsPdf: boolean
  templateEntryReportAsPdf: boolean
  templateRentalAggrementAsPdf: boolean
  templateTravelRegisterAsPdf: boolean
  tennis_court?: boolean
  timezoneId: string
  transferAccount?: string
  transferData?: string
  transferPercent?: number
  transporToAirport?: boolean
  twitter?: string
  update: boolean
  updateInBookingEngine: boolean
  useAutomaticPayment?: boolean
  useHotelCounter?: boolean
  valet_parking?: boolean
  verifiedByAvailroom: boolean
  web?: string
  webPriority: number
  whatsApp?: string
  wheelchair_access?: boolean
  wifi?: boolean
  withoutExtraSeats?: number
  youtube?: string
  zoom: number
  bookingEngineUrl?: string
  checkOutAutomatic?: number
  descriptionId?: string
  emailReserveOpinionHour?: number
  entryReportImageId?: string
  flexMyRoom?: boolean
  place2?: string
  provinceId?: string
  roomService?: boolean
  zoneId?: string
  autonomousCommunityId?: string
  commercialName?: string
  rentalAgreementUrlDescriptionId?: string
  bookingEngineParentId?: string
  guardiaCivil?: boolean
  hospederiaIdentifier?: string
  hospederiaPass?: string
  hospederiaUser?: string
  policia?: boolean
  pinterest?: string
  hotelCategoryId?: string
  hotelTypeId?: string
}
